import { useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import TableForm2s from "../../../../components/TableFormScrb";
import { formatDate } from "../../../../commons/FormatValue";
import { useLocation, useNavigate } from "react-router-dom";
import TechWorkClosedService from "../../../../services/techworkclose.service";
import JobTypeService from "../../../../services/jobtype.service";
import { filteredNoneMultiItemInArray } from "../../../../utils/ManageArray";

export default function ReportView() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [WorkNo, setWorkNo] = useState([]);
  const { state } = useLocation()

  useEffect(() => {
    // setJobType(state?.arrJobType)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeService.getJobTypesForTechPlan(),
      callback: (res) =>
        setJobType(filteredNoneMultiItemInArray(res, "Id"))
    });
  }, []);

  const columns = [
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      width: "180px",
      readOnly: true
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      width: "180px",
      readOnly: true
    },
    {
      name: "Cus_No",
      label: "เลขที่สาขา",
      width: "180px",
      readOnly: true
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      width: "250px",
      readOnly: true
    },
    {
      name: "Detail",
      label: "รายละเอียดสินค้า",
      readOnly: true,
      showTooltip: true
    },
    {
      name: "Equip_No",
      label: "หมายเลขเครื่อง",
      width: "180px",
      readOnly: true
    },
    {
      name: "Tech_work_doc",
      label: "เลขที่ปฏิบัติงาน",
      readOnly: true
    },
    {
      name: "Service_rep_no",
      label: "หมายเลขบริการ",
      readOnly: true
    },
    // {
    //   name: "สถานะใบสั่งงาน",
    //   selector: (row) => row.Seq_St_Name,
    //   sortable: true,
    //   minWidth: "200px"
    // },
    {
      label: "",
      type: "activeButton"
    }
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      // value: ,
      disabled: true,
      size: 4
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      // value: ,
      disabled: true,
      size: 4
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 4,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "start",
      label: "วันที่ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      max: "updatedAt"
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      min: "createdAt"
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechWorkClosedService.getSeqNo(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              seq_no: arr.seqJob.seqNo
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
  ];

  const getDataTable = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({ page: page, limit: limit, ...search })
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechWorkClosedService.getJob(q),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });
  }
  function initData(data) {
    const newArray = data?.map((items) => {
      let detail = ''
      items.ServiceRequestDt?.map(ele => {
        detail += ele.BillOfReqDt?.Item?.Item_Name_TH + ', '
      })

      return{
      ...items,
      Id: items.id, // for edit page
      // Tech_Rev_Date: formatDate(items.TechnicianReceive[0]?.tech_rev_date),
      Job_Type_Id: items.BillOfReqHd?.Job_Type_Id,
      Job_Type_Name: items.BillOfReqHd?.Job_Type_Name || items.TechnicianPlan?.SeqInstalljob?.JobTypes.Job_Type_Name,
      Seq_No: items.TechnicianPlan.seq_no,
      Cus_Code: items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Code
      ,
      Cus_Name: items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Name
      ,
      Cus_No: items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_NumBranch
      ,
      Job_Cus_Date: formatDate(items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Job_Cus_Date),
      Depart_St_Name: items.TechnicianPlan?.DepartJob?.Depart_St_Name,
      Seq_St_Name: items.SequneceStatus?.Seq_St_Name,
      // Equip_No: ,
      Detail: detail.slice(0,-2),
      Tech_work_doc: items.TechnicianPlan.TechWorkJob?.tech_work_doc,
      Service_rep_no: items.TechnicianPlan.TechWorkClosed?.service_rep_no,
    }
  });
    setTableData(newArray || [])
  }

  function handleSubmitDelete(e, data) {
    // console.log(data.id)
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechWorkClosedService.deleteTechWorkClose(id),
      navigated: () => getDataTable()
    });
  }

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-center align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2">
            ข้อมูลหมายเลขใบงานบริการ
          </Card.Title>
        </Card.Header>

        <Card.Body>
          <InputSearch
            inputField={searchInput}
            field={searchInput}
            searchCallback={search => search ? getDataTable(search) : setTableData([])}
          />
        </Card.Body>
      </Card>

      <Form noValidate>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">

            </Card.Title>

            <Button
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill h-100"
              onClick={() => navigate("add", {
                state: { JobType: JobType }
              })}
            >
              เพิ่มหมายเลขใบงานบริการ
            </Button>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData}
              columns={columns}
              pending={loading}
              searchFilter={tableData}
              rowCount={allCountData}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              previewButton
              editButton
              deleteButton
              onDeleteCallback={handleSubmitDelete}
            />
          </Card.Body>
          <Card.Body>
            <center>
              <Button
                variant="outline-secondary"
                className="px-4 py-2 text-dark rounded-pill"
                onClick={() =>
                  navigate("/service_work/perform", {
                    state: { name: "CloseJob" }
                  })
                }
              >
                ย้อนกลับ
              </Button>
            </center>
          </Card.Body>
        </Card>
      </Form>
    </>
  );
}